export default function ViewArchivedReportDirective() {
  return {
    restrict: 'E',
    template: require('./view-archived-report.directive.html'),
    scope: {
      reportInstanceArchiveId: '@',
      tooltip: '@',
      tooltipAppendToSelector: '@',
      iconType: '@',
      iconSizeClass: '@',
      iconColorClass: '@',
    },
    controller: 'ViewArchivedReportDirectiveController',
    controllerAs: 'viewArchivedReportVM',
    bindToController: true,
    replace: true,
  };
}
